import React, { useContext, useState, useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import * as S from './AlarmMakeModal.style';
import { makeAlarm } from '../../../services/apis/CustomApi';
import { ACTIONS, DISPLAYS } from '../../../data/motion';
import { RootStoreContext } from '../../../App';
import { useForm, SubmitHandler } from 'react-hook-form';
import UserSelectDropdown from './UserSelectDropdown';
import CustomTimeInput from '../../../components/input/CustomTimeInput';
import CalendarInput from '../../../components/input/CalendarInput';

const date = new Date();
const formattedDate = date.toISOString().slice(0, 10);

function formatted(dateStr) {
	let parts = dateStr.split('-');
	let month = parts[1].padStart(2, '0');
	let day = parts[2].padStart(2, '0');
	let formattedDate = `${parts[0]}-${month}-${day}`;
	return formattedDate;
}

const DefaultAlarmMakeModal = observer(
	({ setMakeModal, category = 'schedule', onLoad }) => {
		const { alarmStore } = useContext(RootStoreContext);
		const modalRef = useRef(null);

		const [days, setDays] = useState(['x', 'x', 'x', 'x', 'x', 'x', 'x']);
		const [faceUserIds, setFaceUserIds] = useState([]);
		const [isError, setIsError] = useState(false);
		const [target, setTarget] = useState('Anyone');

		// 바깥 클릭 시 모달 닫기
		useEffect(() => {
			const handleClickOutside = (event) => {
				if (modalRef.current && !modalRef.current.contains(event.target)) {
					setMakeModal(false);
				}
			};

			document.addEventListener('mousedown', handleClickOutside);
			// body 스크롤 잠금
			const prevOverflow = document.body.style.overflow;
			const prevTouch = document.body.style.touchAction;
			document.body.style.overflow = 'hidden';
			document.body.style.touchAction = 'none';
			return () => {
				document.removeEventListener('mousedown', handleClickOutside);
				document.body.style.overflow = prevOverflow;
				document.body.style.touchAction = prevTouch;
			};
		}, [setMakeModal]);

		const { register, handleSubmit, setValue, watch } = useForm({
			defaultValues: {
				start_date: formattedDate,
				end_date: formattedDate,
				start_time: '00:00',
				end_time: '23:59',
				time: '00:00',
				days: ['x', 'x', 'x', 'x', 'x', 'x', 'x'],
			},
		});

		const toggleDay = (index) => {
			setDays((state) => {
				const tempState = [...state];
				tempState[index] = days[index] === 'o' ? 'x' : 'o';
				return tempState;
			});
		};

		const onSubmit = async (data) => {
			if (
				(target === 'Someone' && faceUserIds.length > 0) ||
				target === 'Anyone'
			) {
				const startDate = formatted(data.start_date) + 'T00:00:00';
				const endDate = formatted(data.end_date) + 'T00:00:00';

				console.log('startDate', startDate);

				await alarmStore.setMakeAlarm({
					category,
					name: data.name,
					info: data.name,
					start_date: startDate || formattedDate,
					end_date: endDate || formattedDate,
					start_time: data.start_time,
					end_time: data.end_time,
					time: '00:00',
					day: days.join(''),
					repeat: '5M',
					target: target,
					scenario_id_array: [],
					face_user_id_array: target === 'Someone' ? faceUserIds : [],
					priority: 150,
					state: true,
				});
				setMakeModal(false);
				onLoad();
				setIsError(false);
			} else {
				setIsError(true);
			}
		};

		return (
			<S.Container ref={modalRef}>
				<S.Header>
					<S.CloseButton onClick={() => setMakeModal(false)}>+</S.CloseButton>
					<p>알림 설정</p>
					<form onSubmit={handleSubmit(onSubmit)}>
						<S.SaveButton type='submit'>저장</S.SaveButton>
					</form>
				</S.Header>
				<S.Content>
					<S.AlarmContent>
						<div className='title'>
							<input
								placeholder='알림 이름을 입력하세요'
								type='text'
								{...register('name')}
							/>
						</div>
						<div className='time cell'>
							<div className='content_flex'>
								<p className='cellTitle'>알림 시간</p>
							</div>
							<div className='timeBox'>
								<CustomTimeInput
									value='09:00'
									onChange={(time) => setValue('start_time', time)}
								/>
								<span>부터</span>
								<CustomTimeInput
									value='18:00'
									onChange={(time) => setValue('end_time', time)}
								/>
								<span>까지</span>
							</div>
						</div>
						<div className='date cell'>
							<div className='content_flex'>
								<p className='cellTitle'>활성화 기간</p>
							</div>
							<div className='timeBox'>
								<CalendarInput
									value={watch('start_date')}
									onChange={(date) => setValue('start_date', date)}
									placeholder='시작 날짜'
								/>
								<span>부터</span>
								<CalendarInput
									value={watch('end_date')}
									onChange={(date) => setValue('end_date', date)}
									placeholder='종료 날짜'
								/>
								<span>까지</span>
							</div>
							<div className='dayButtons'>
								{['월', '화', '수', '목', '금', '토', '일'].map(
									(day, index) => {
										return (
											<label
												key={index}
												id={`day_${index}`}
												onClick={() => toggleDay(index)}
												className={days[index] === 'o' ? 'day clicked' : 'day'}>
												{day}
												<input
													id={`day_${index}`}
													key={index}
													type='hidden'
													value={days[index] === 'o' ? 'o' : 'x'}
													{...register(`days[${index}]`)}
												/>
											</label>
										);
									},
								)}
							</div>
						</div>
						<div className='user cell'>
							<div>
								<p className='cellTitle'>
									알림 대상 설정
									{isError &&
										target === 'Someone' &&
										faceUserIds.length <= 0 && (
											<span className='error'>사용자를 선택해주세요.</span>
										)}
									{isError && target === '' && (
										<span className='error'>알림 대상을 설정해주세요.</span>
									)}
								</p>
							</div>
							<div className='userSelect'>
								<div
									className={target === 'Anyone' ? 'clicked' : ''}
									onClick={() => {
										setTarget('Anyone');
									}}>
									인지되는 모든 사람
								</div>
								<div
									className={target === 'Someone' ? 'clicked' : ''}
									onClick={() => {
										setTarget('Someone');
									}}>
									선택된 사람
								</div>
								{target === 'Someone' && (
									<>
										<UserSelectDropdown
											users={alarmStore.users}
											selectedUsers={faceUserIds}
											onUserSelect={(userId) => {
												setTarget('Someone');
												setFaceUserIds((state) => [...state, userId]);
											}}
											placeholder='사용자 선택 +'
										/>
										{faceUserIds.map((user, index) => {
											return (
												<div
													key={index}
													className='alarm-user'
													onClick={() => {
														setFaceUserIds((state) =>
															state.filter((item) => item !== user),
														);
													}}>
													{
														alarmStore.users?.filter((alarmUser) => {
															console.log(
																alarmUser,
																alarmUser.id,
																+user,
																alarmUser.id == user,
															);
															return alarmUser.id == user;
														})[0]?.name
													}
												</div>
											);
										})}
									</>
								)}
							</div>
						</div>
					</S.AlarmContent>
				</S.Content>
			</S.Container>
		);
	},
);

export default DefaultAlarmMakeModal;
